(() => {
  'use strict';

  /*
   * =========================================================
   * THE SEVENTH SENSE
   * MEDIA-WITH-TEXT: BILD ÜBERNIMMT BUTTON-LINK
   * =========================================================
   *
   * In jedem "Multimedia mit Text"-Abschnitt:
   *
   * - Produkt-Link aus dem vorhandenen Button holen
   * - sichtbares Hauptbild derselben Sektion klickbar machen
   * - Bild verwendet automatisch dasselbe Ziel
   *
   * Der Link muss dadurch nur einmal im Theme-Editor
   * beim Button gepflegt werden.
   * =========================================================
   */

  function linkMediaImages() {
    const sections = document.querySelectorAll(
      '[id*="__media_with_text_"]'
    );

    sections.forEach((section) => {
      /*
       * Produkt-Link innerhalb der Sektion suchen.
       */
      const buttonLink =
        section.querySelector('a[href*="/products/"]') ||
        section.querySelector('a[href]');

      if (!buttonLink) {
        return;
      }

      const href = buttonLink.getAttribute('href');

      if (!href) {
        return;
      }

      /*
       * Emporium verwendet für das Bild:
       *
       * 1. blur = Platzhalter
       * 2. lazyload opacity-0 = echtes Hauptbild
       *
       * Deshalb gezielt das echte Bild verwenden.
       */
      const image =
        section.querySelector('img.lazyload:not(.blur)') ||
        section.querySelector('img:not(.blur)');

      if (!image) {
        return;
      }

      /*
       * Bereits korrekt verarbeitet.
       */
      if (image.dataset.tssLinkedImage === href) {
        return;
      }

      /*
       * Falls das Bild bereits in einem Link steckt,
       * einfach dessen Ziel aktualisieren.
       */
      const existingLink = image.closest('a');

      if (existingLink && section.contains(existingLink)) {
        existingLink.href = href;

        existingLink.setAttribute(
          'aria-label',
          buttonLink.textContent.trim() || 'Produkt öffnen'
        );

        image.style.cursor = 'pointer';
        image.dataset.tssLinkedImage = href;

        return;
      }

      /*
       * Neues Link-Element erzeugen.
       */
      const link = document.createElement('a');

      link.href = href;

      link.setAttribute(
        'aria-label',
        buttonLink.textContent.trim() || 'Produkt öffnen'
      );

      link.style.display = 'block';

      /*
       * Bild in den Link einpacken.
       */
      image.parentNode.insertBefore(link, image);
      link.appendChild(image);

      image.style.cursor = 'pointer';
      image.dataset.tssLinkedImage = href;
    });
  }


  /*
   * ---------------------------------------------------------
   * INITIALER START
   * ---------------------------------------------------------
   */

  function runLinkedImages() {
    linkMediaImages();

    setTimeout(linkMediaImages, 250);
    setTimeout(linkMediaImages, 750);
    setTimeout(linkMediaImages, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      runLinkedImages
    );
  } else {
    runLinkedImages();
  }


  /*
   * ---------------------------------------------------------
   * DYNAMISCHE EMPORIUM-UPDATES
   * ---------------------------------------------------------
   */

  let updateScheduled = false;

  const observer = new MutationObserver(() => {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;

    requestAnimationFrame(() => {
      linkMediaImages();
      updateScheduled = false;
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
